import React, { Component } from "react";

class ModalInfoEst extends Component {
  render() {
    return (
      <div id="detalleEstablecimiento">
        <div className="row">
          <div className="col-12">
            <fieldset className="col-md-12">
              <legend>Datos generales</legend>
              <div className="row">
                <div className="form-group col-md-6">
                  <label>Razón social</label>
                  <div className="form-control">
                    {this.props.establecimiento.razon_social}
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label>Teléfono activo</label>
                  <div className="form-control">
                    {this.props.establecimiento.telefono}
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label>Correo electrónico</label>
                  <div className="form-control">
                    {this.props.establecimiento.correo_electronico}
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label>Cédula RUC</label>
                  <div className="form-control">
                    {this.props.establecimiento.numero_de_identificacion}
                  </div>
                </div>
                <div className="form-group col-md-12">
                  <label>Dirección</label>
                  <div className="form-control">
                    {this.props.establecimiento.direccion}
                  </div>
                </div>
                { this.props.establecimiento.nacional == "0" ?
                  (<div className="form-group col-md-12">
                    <label>País</label>
                    <div className="form-control">
                      {this.props.establecimiento.pais_texto}
                    </div>
                  </div>)
                :
                  <><div className="form-group col-md-6">
                    <label>Municipio</label>
                    <div className="form-control">
                      {this.props.establecimiento.municipio}
                    </div>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Departamento</label>
                    <div className="form-control">
                      {this.props.establecimiento.departamento}
                    </div>
                  </div></>
                }
                <div className="form-group col-md-6">
                  <label>Latitud</label>
                  <div className="form-control">
                    {this.props.establecimiento.latitud}
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label>Longitud</label>
                  <div className="form-control">
                    {this.props.establecimiento.longitud}
                  </div>
                </div>
              </div>
            </fieldset>
            <hr></hr>
            <fieldset className="col-md-12">
              <legend>Detalles del representante legal</legend>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Apellido paterno</th>
                      <th className="text-center">Apellido materno</th>
                      <th className="text-center">Correo electrónico</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.establecimiento.representante_legal.length >
                    0 ? (
                      this.props.establecimiento.representante_legal.map(
                        (rep, index) => (
                          <tr key={index} id={index}>
                            <td className="text-center">{rep.nombres}</td>
                            <td className="text-center">
                              {rep.apellido_paterno}
                            </td>
                            <td className="text-center">
                              {rep.apellido_materno}
                            </td>
                            <td className="text-center">
                              {rep.correo_electronico}
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td className="text-center"></td>
                        <td className="text-right">No tiene</td>
                        <td className="text-left"> representantes legales</td>
                        <td className="text-center"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </fieldset>
            <hr></hr>
            <fieldset className="col-md-12">
              <legend>Detalles de regentes</legend>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Nombre</th>
                      <th className="text-center">Apellido paterno</th>
                      <th className="text-center">Apellido materno</th>
                      <th className="text-center">Guid</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.establecimiento.regentes.length > 0 ? (
                      this.props.establecimiento.regentes.map((rep, index) => (
                        <tr key={index} id={index}>
                          <td className="text-center">{rep.nombres}</td>
                          <td className="text-center">
                            {rep.apellido_paterno}
                          </td>
                          <td className="text-center">
                            {rep.apellido_materno}
                          </td>
                          <td className="text-center">{rep.guid}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center"></td>
                        <td className="text-right">No tiene</td>
                        <td className="text-left">regentes</td>
                        <td className="text-center"></td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </fieldset>
            <hr></hr>
            <fieldset className="col-md-12">
              <legend>Características del establecimiento</legend>
              <div className="form-group col-md-12">
                <label>Área total(m²):</label>
                <div className="form-control">
                  {this.props.establecimiento.area}
                </div>
              </div>
              <div className="form-group col-md-12">
                <label>Dirección de bodegas y almacenamiento:</label>
                <div className="form-control">
                  {this.props.establecimiento.direccion_bodegas}
                </div>
              </div>
              <hr></hr>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Condiciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.establecimiento.condiciones.length > 0 ? (
                      this.props.establecimiento.condiciones.map((con, index) => (
                        <tr key={index} id={index}>
                          <td className="text-left">{con.condiciones}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center">No tiene condiciones</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </fieldset>
            <hr></hr>
            <fieldset className="col-md-12">
              <legend>Actividades</legend>
              <div className="table-responsive">
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-left">Actividad</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.establecimiento.actividades.length > 0 ? (
                      this.props.establecimiento.actividades.map((rep, index) => (
                        <tr key={index} id={index}>
                          <td className="text-left">{rep.actividad}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="text-center">No tiene actividades con licencia activa</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </fieldset>
            <hr></hr>
            <div className="btn-group float-right">
            <button
              type="button"
              onClick={() => {
                this.props.component.closeModal();
              }}
              className="btn btn-danger"
            >
              Regresar
            </button>
          </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalInfoEst;